/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import Icon from '@roo/roo/Icon'
import styles from './index.module.less'

export default () => (
  <Icon className={styles.loadingIcon} name="loading" size={28} color="red" />
)
